import { InvoiceDTO, Permission } from 'core/api';
import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';
import { sendDocumentEmail } from 'pos/modules/helpers/document-emailing';
import { InvoiceFacade } from 'pos/facades';

declare global {
	interface CommandType {
		sendInvoiceByEmail: (invoice: InvoiceDTO) => Promise<Result>
	}
}

Command.register('sendInvoiceByEmail', Preconditions.and(Preconditions.ensure(Permission.Ticket_SendEmail), Preconditions.ensureIsNotLite), async (invoice: InvoiceDTO): Promise<Result> => {
	const options = await InvoiceFacade.getEmailOptions(invoice.Id);
	return sendDocumentEmail({
		getDefaultOptions: () => options,
		send: InvoiceFacade.sendEmail
	});
});
